import type { ScopeType } from '../enums/ScopeType'
import type { ShowcaseModeType } from '../enums/ShowcaseModeType'
import type { ShowcaseType } from '../enums/ShowcaseType'

export class ShowcaseMiniEntity {
  id?: number
  order?: number
  name?: string | null
  type?: ShowcaseType
  channelId?: number | null
  channelName?: string | null
  disabled?: boolean
  scopeType?: ScopeType
  isShiftIgnored?: boolean
  mode?: ShowcaseModeType
}
